import React from "react";
import checkIcon from "../images/zta_checkmark.svg";
import chartImage from "../images/quantvps_image.webp";
import analyzerImage from "../images/zta_vps_desktop.png";
import LargeHeaderTitle from "./LargeHeaderTitle";

const ZTADoneForYou = () => {
  return (
    <div className="w-full px-4 md:px-0 pt-20 pb-16 flex flex-col items-center text-center">
      <LargeHeaderTitle title="Fully Automated, " highlight="Done For You" />
      <p className="text-slate-300 text-md md:text-lg max-w-[600px] mb-8">
        We handle everything — from VPS setup to NinjaTrader install. All our
        strategies, settings, and PortfolioAnalyzer come fully installed. Just
        log in and let the algos run.
      </p>

      <div className="flex flex-col md:flex-row gap-6 mb-10">
        <div className="flex items-center gap-2">
          <img src={checkIcon} alt="Check" className="w-5 h-5" />
          <span className="text-white font-medium">Powerful Algorithms</span>
        </div>
        <div className="flex items-center gap-2">
          <img src={checkIcon} alt="Check" className="w-5 h-5" />
          <span className="text-white font-medium">VPS Setup Handled</span>
        </div>
        <div className="flex items-center gap-2">
          <img src={checkIcon} alt="Check" className="w-5 h-5" />
          <span className="text-white font-medium">Software Included</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-[1200px] w-full px-4">
        <div className="rounded-xl overflow-hidden border border-[#f45925]/30 shadow-lg">
          <img
            src={chartImage}
            alt="Chart Sample"
            className="object-cover w-full h-full"
          />
        </div>
        <div className="rounded-xl overflow-hidden border border-[#f45925]/30 shadow-lg">
          <img
            src={analyzerImage}
            alt="Portfolio Analyzer"
            className="object-cover w-full h-full"
          />
        </div>
      </div>
    </div>
  );
};

export default ZTADoneForYou;
